import React from 'react';

export function ExplainIcon() {
	return (
		<svg
			width="40"
			height="40"
			viewBox="0 0 40 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19.5679 4.10035C24.3051 3.35382 28.7036 6.89063 31.4882 10.785C34.0938 14.4291 34.5792 19.097 33.3735 23.4082C32.2404 27.4602 29.1718 30.4656 25.4376 32.4215C21.4964 34.4858 16.8947 36.0335 12.863 34.1511C8.79307 32.2508 6.29292 27.8246 6.0115 23.3515C5.77037 19.519 9.37734 17.0632 11.5902 13.9207C14.1445 10.2934 15.178 4.79215 19.5679 4.10035Z"
				fill="#8252DD"
			/>
			<path
				d="M19.3724 21.5586C18.4591 18.7416 20.0023 15.7175 22.8193 14.8041C25.6363 13.8908 28.6604 15.434 29.5738 18.251C30.4871 21.068 28.9439 24.0921 26.1269 25.0055C23.3098 25.9188 20.2858 24.3756 19.3724 21.5586Z"
				fill="white"
			/>
			<path
				d="M13.5481 24.604C11.2901 22.688 11.0129 19.3042 12.9289 17.0462C14.8449 14.7882 18.2286 14.5109 20.4867 16.427C22.7447 18.343 23.022 21.7267 21.1059 23.9847C19.1899 26.2428 15.8062 26.52 13.5481 24.604Z"
				fill="white"
			/>
			<path
				d="M11.9681 14.2037L17.4232 12.332C17.9575 12.1486 18.5392 12.4331 18.7226 12.9674L19.08 14.009C19.2633 14.5433 18.9788 15.1251 18.4445 15.3084L12.9894 17.1801C12.4551 17.3635 11.8734 17.079 11.6901 16.5447L11.3326 15.5031C11.1493 14.9688 11.4338 14.3871 11.9681 14.2037Z"
				fill="#000A23"
			/>
			<path
				d="M23.7478 10.245L29.3469 11.6277C29.8953 11.7631 30.2301 12.3175 30.0946 12.8658L29.8306 13.935C29.6952 14.4833 29.1408 14.8181 28.5925 14.6827L22.9934 13.2999C22.445 13.1645 22.1102 12.6102 22.2457 12.0618L22.5097 10.9927C22.6451 10.4443 23.1994 10.1095 23.7478 10.245Z"
				fill="#000A23"
			/>
			<path
				d="M20.7196 21.2986C20.3214 19.6903 21.3024 18.0638 22.9108 17.6656C24.5191 17.2675 26.1456 18.2485 26.5437 19.8568C26.9419 21.4651 25.9609 23.0917 24.3526 23.4898C22.7442 23.888 21.1177 22.9069 20.7196 21.2986Z"
				fill="#000A23"
			/>
			<path
				d="M15.729 23.2849C14.4656 22.213 14.3105 20.3198 15.3825 19.0565C16.4545 17.7931 18.3476 17.638 19.611 18.71C20.8743 19.782 21.0294 21.6751 19.9574 22.9385C18.8855 24.2018 16.9923 24.3569 15.729 23.2849Z"
				fill="#000A23"
			/>
			<path
				d="M20.5377 28.6118C19.4046 28.4949 18.5396 27.6011 18.4168 26.5138C18.3849 26.2314 18.6437 26.0238 18.9264 26.0529L22.6375 26.4358C22.9202 26.465 23.1312 26.7211 23.0423 26.9911C22.7001 28.0304 21.6708 28.7287 20.5377 28.6118Z"
				fill="#27292C"
			/>
		</svg>
	);
}
